interface User {
	// TODO: What is the shape of the returned JSON?
}

export default function generateReactionTooltip(
	emoji: string,
	upvotedUsers: User[],
): string {
	if (upvotedUsers.length === 0) {
		return ""
	} else if (upvotedUsers.length === 1) {
		return `${upvotedUsers[0]} said ${emoji}`
	} else if (upvotedUsers.length === 2) {
		return `${upvotedUsers[0]} and ${upvotedUsers[1]} said ${emoji}`
	} else if (upvotedUsers.length === 3) {
		const tempArray = upvotedUsers.slice(0, upvotedUsers.length - 1)
		return `${tempArray.join(", ")} and ${
			upvotedUsers[upvotedUsers.length - 1]
		} said  ${emoji}`
	} else {
		const tempArray = upvotedUsers.slice(0, 3)
		return `${tempArray.join(", ")} and others said  ${emoji}`
	}
}
